export class OneOffFx {
  static createFX(
    x: number,
    y: number,
    animation: string,
    scene: Phaser.Scene,
    afterAnimation: () => void,
    options?: {
      depth: number;
    }
  ) {
    const sprite = scene.add.sprite(x, y, "atlas");
    sprite.play(animation);
    sprite.setDepth(options?.depth || 2000);
    sprite.once("animationcomplete", () => {
      if (sprite) {
        sprite.destroy();
        afterAnimation();
      }
    });
  }
}
